export default __webpack_public_path__ + "static/media/girl7.620ffc11.jpg";